// React
import React from 'react';
import { Button } from 'react-bootstrap';
// Styles
import './styles.scss';
// Icons
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from 'react-icons/md';

/**
 * @param {Object} props.text - Text to be displayed in the button
 * @param {Object} props.color - Color to be applied to the button, it can be:
 *                                  'base': transparent with dark grey font color (default)
 *                                  'outline': transparent with dark grey outline and font color
 *                                  'primary': Primary background with white font color
 * @param {Object} props.className - Class to be applied to the button
 * @param {Function} props.onClick - On click function handler
 * @param {Object} props.iconPos - Position of the icon:
 *                                      'left': Icons positioned left to the text
 *                                      'right': Icons positioned right to the text (default)v
 */
class ButtonIconText extends React.Component {
    constructor(props) {
        super(props);
        const color = props.color === 'outline' || props.color === 'fill' ? props.color : 'base';
        this.className = `btn-${color} ${props.className ? props.className : ''}`;
    }

    render() {
        return (
            <Button className={this.className} variant="light" onClick={this.props.onClick} disabled={this.props.isDisabled}>
                <TextWithIcon iconPos={this.props.iconPos} text={this.props.text} />
            </Button>
        );
    }
}

/**
 * Text + Icon component
 * @param {String} props.iconPos - 3 options: 'right', 'left', null
 * @param {String} props.text - The text next to the icon
 * @returns {JSX template}
 */
const TextWithIcon = (props) => {
    // If the icon position is in the right
    if (props.iconPos === 'right') {
        return (
            <div>
                {props.text}
                <MdKeyboardArrowRight />
            </div>
        );
    } else if (props.iconPos === 'left') {
        // If the icon position is in the left
        return (
            <div>
                <MdKeyboardArrowLeft />
                {props.text}
            </div>
        );
    }
    // If the icon position is not specified only the text is displayed
    return props.text;
};

export default ButtonIconText;
